import { ReferralsCondition } from '@recruitee/http-types';
import { createEntityCollectionStore, getEntityCollectionActions, Scope } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ReferralsCondition>()('ReferralsConditionsCollection', {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id!);
      return {
        updateAll: (state, payload: { conditions: ReferralsCondition[]; scope?: Scope }) =>
          adapter.markAsPending(state, { scope: payload.scope || null, entities: [] }),
        updateAllSuccess: actions.fetchCollectionSuccess,
        updateAllFailed: actions.fetchCollectionFailed,
      };
    },
  });

export {
  actions as ReferralsConditionsCollectionActions,
  selectors as ReferralsConditionsCollectionSelectors,
  reducer as ReferralsConditionsCollectionReducer,
  namespace as ReferralsConditionsCollectionNamespace,
};
